import React from "react";

type Section = {
  id: string;
  component: React.ReactNode;
};

interface PrintableDocumentProps {
  header?: React.ReactNode;
  sections: Section[];
  contentRef: React.RefObject<HTMLDivElement>;
}

export const PrintableDocument: React.FC<PrintableDocumentProps> = ({
  header,
  sections,
  contentRef,
}) => {
  return (
    <div className="w-full mx-auto p-8 bg-white shadow-md print:shadow-none print:mx-0 print:p-0 print:w-full hidden">
      <div ref={contentRef} className="print-container">
        <style>
          {`
              @media print {
                body, html { 
                  width: 100% !important; 
                  margin: 0 !important; 
                  padding: 0 !important; 
                }
                .print-container { 
                  width: 100% !important; 
                  margin: 0 !important; 
                  padding: 0 !important; 
                }
              }
            `}
        </style>

        {header && (
          <div className="mb-8 pb-4 border-b print:mb-6 print:pb-2">
            {header}
          </div>
        )}

        <div className="print-content">
          {sections.map(({ id, component }) => (
            <div key={id} className="mb-6 print:mb-4">
              {component}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
